module.exports = __webpack_public_path__ + "static/media/logo-themoviedb.02a9430b.svg";